import { Box } from '@mui/material'
import DictationWaveform from './DictationWaveform'
import styles from './index.module.scss'

export default function AiAskBarDictationWaveformRow({ isDictating, levels, minBarPx, maxBarPx }) {
  return (
    <Box className={styles.bottomRowMain}>
      {isDictating ? <DictationWaveform levels={levels} minBarPx={minBarPx} maxBarPx={maxBarPx} /> : null}
    </Box>
  )
}
